<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import DynamicAnkerView from "../../../../../component/common/Link/DynamicAnkerView.svelte";

    const dispatcher = createEventDispatcher();


    export let tag;
    export let jumpUrl = null;
    export let isShowDelete = false;
    export let canClick = false;

    $: title = (() => {
        if (tag == null) {
            return '';
        }
        const latestUseAt = tag.latest_use_at;
        if (latestUseAt == null) {
            return '';
        }

        return `最終使用日時:${latestUseAt}`;
    })();

    let isLoading = false;


    onMount(() => {
    });

    function onClickNameCount() {
        console.log('onClickNameCount');
        if (!canClick) {
            return;
        }
        if (jumpUrl != null) {
            // jumpUrl が指定されている場合は無効
            return;
        }
        dispatcher('click', {tag: tag});
    }

    function onClickDelete() {
        dispatcher('delete');
    }

</script>

<div class="tag-view">

    <DynamicAnkerView href={jumpUrl} isOtherTab={true}>
        <div class="name-count-area" on:click={onClickNameCount} class:clickable={canClick}
             title={title}
        >
            <div class="name">
                { tag.name }
            </div>
            <div class="use-count" title="使用回数">
                ({ tag.use_count})
            </div>

        </div>

    </DynamicAnkerView>

    {#if isShowDelete}
        <div class="delete-area" on:click={onClickDelete}>
            ✕
        </div>
    {/if}


</div>
<style lang="scss">
    .tag-view {
        border-style: solid;
        border-width: 1px;
        border-color: #0006;
        border-radius: 0.25em;

        padding-left: 0.25em;
        padding-right: 0.25em;

        display: inline-flex;
        align-items: center;
        gap: 0.5em;

        .name-count-area {
            display: flex;
            align-items: center;
            gap: 0.5em;
            white-space: nowrap;

            .name {
                //min-width: 3em;
                user-select: none;
                white-space: nowrap;
            }

            .use-count {
                font-size: 0.5em;
                opacity: 0.5;
            }

            &.clickable {
                cursor: pointer;
            }
        }


        .delete-area {
            margin-left: 0.5em;
            opacity: 0;
            cursor: pointer;
            font-size: 0.5em;
        }

        &:hover {
            .delete-area {
                opacity: 1;
            }
        }
    }
</style>